import { render, staticRenderFns } from "./pointsLeafActive.vue?vue&type=template&id=5e3af94e"
import script from "./pointsLeafActive.vue?vue&type=script&lang=js"
export * from "./pointsLeafActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports